import type { VectorLayerZoneStyle } from '../models';

export const defaultZoneStyle: VectorLayerZoneStyle = {
  color: 'rgba(255,255,255,0.4)',
  strokeColor: '#3399CC',
  strokeWidth: 1.25,
  pointRadius: 2,
  arrowRadius: 8,
  textColor: '#333333',
  textStrokeColor: '#00000000',
  textStrokeWidth: 1.25,
  textBackgroundColor: '#FFFFFF99',
  textOverflow: true,
  textPadding: [5, 5, 5, 5],
  fontFamily: 'Quattrocento Sans',
  fontWeight: 'bold',
  fontSize: '14px',
  fontLineHeight: '1'
};
